// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Club squad sheet — the group is a court, not a MUI form. */
.gd-sheet.gmd-dlg .MuiDialog-paper,
.gd-sheet .gmd-dlg-paper,
.gmd-dlg.gd-sheet .gmd-dlg-paper {
  --gd-display: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  --gd-body: "IBM Plex Sans", Poppins, system-ui, sans-serif;
  font-family: var(--gd-body);
  border-radius: 22px !important;
  overflow: hidden;
  background: var(--surface-color, #fff) !important;
  color: var(--text-color, #111) !important;
  max-width: 720px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--border-color, rgba(15, 23, 42, 0.1)));
  box-shadow:
    0 28px 70px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent),
    0 2px 0 color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent) inset;
}

.gd-sheet__club {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1.15rem 1.25rem 0.95rem;
  background:
    linear-gradient(
      90deg,
      color-mix(in srgb, var(--brand-primary, #0877bc) 92%, #000) 0 7px,
      transparent 7px
    ),
    radial-gradient(
      90% 140% at 0% 0%,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) 0%,
      transparent 58%
    ),
    var(--surface-color, #fff);
}

.gd-sheet .gmd-dlg__header-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.gd-sheet .gmd-dlg__header-actions .gmd-dlg__close,
.gd-sheet .gmd-dlg__header-actions .gmd-dlg__edit {
  position: static !important;
}

.gd-sheet .gmd-dlg__edit {
  color: var(--text-secondary, #666) !important;
  background: rgba(0, 0, 0, 0.04) !important;
}

.dark-mode .gd-sheet .gmd-dlg__edit {
  background: rgba(255, 255, 255, 0.06) !important;
  color: var(--text-secondary, #aaa) !important;
}

.gd-sheet .gmd-dlg__edit:hover {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;
  color: var(--brand-primary, #0877bc) !important;
}

.gd-sheet__club--with-edit .gd-sheet__club-copy {
  padding-right: 4.75rem;
}

.gd-sheet__club-mark {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  object-fit: contain;
  flex-shrink: 0;
  background: var(--surface-color, #fff);
  border: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
  box-shadow: 0 8px 20px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);
  padding: 4px;
}

.gd-sheet__club-mark--fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--gd-display);
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #fff;
  background: var(--brand-primary, #0877bc);
  padding: 0;
}

.gd-sheet__club-copy {
  min-width: 0;
  flex: 1 1;
  padding-right: 2.2rem;
}

.gd-sheet__club-kicker {
  display: block;
  margin: 0 0 0.15rem;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.gd-sheet__club-name {
  margin: 0;
  font-family: var(--gd-display);
  font-size: clamp(1.35rem, 3vw, 1.7rem);
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 0.95;
  text-transform: uppercase;
  color: var(--text-color);
}

.gd-sheet__hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.85rem 1.1rem;
  padding: 0.35rem 1.25rem 1rem;
  border-bottom: 1px solid var(--border-color, rgba(15, 23, 42, 0.08));
}

.gd-sheet__group {
  min-width: 0;
  flex: 1 1;
}

.gd-sheet__group-name {
  margin: 0;
  font-family: var(--gd-display);
  font-size: clamp(1.7rem, 4vw, 2.15rem);
  font-weight: 700;
  letter-spacing: 0.03em;
  line-height: 0.95;
  text-transform: uppercase;
  color: var(--text-color);
}

.gd-sheet__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.85rem;
  margin: 0.45rem 0 0;
  color: var(--text-secondary, #64748b);
  font-size: 0.8rem;
}

.gd-sheet__lede {
  margin: 0.4rem 0 0;
  max-width: 28rem;
  font-size: 0.9rem;
  line-height: 1.4;
  color: var(--text-secondary, #64748b);
}

.gd-sheet__occupancy {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.35rem 0.15rem;
}

.gd-sheet__occupancy-stat {
  display: flex;
  flex-direction: column;
}

.gd-sheet__occupancy-n {
  font-variant-numeric: tabular-nums;
  font-size: 1.45rem;
  font-weight: 650;
  letter-spacing: -0.04em;
  line-height: 1;
  color: var(--text-color);
}

.gd-sheet__occupancy-label {
  margin-top: 0.12rem;
  color: var(--text-secondary, #64748b);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.gd-sheet .gl-court {
  background: var(--brand-primary, #0877bc);
  box-shadow:
    inset 0 0 0 1px color-mix(in srgb, #fff 22%, transparent),
    0 6px 14px color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);
}

.gd-sheet .gl-court__surface {
  background:
    linear-gradient(90deg, color-mix(in srgb, #000 22%, transparent), transparent 18% 82%, color-mix(in srgb, #000 22%, transparent)),
    var(--brand-primary, #0877bc);
}

.gd-sheet__error {
  margin: 0;
  padding: 2rem 1.25rem;
  text-align: center;
  color: #b91c1c;
}

.gd-sheet .gmd-dlg__section-title {
  font-family: var(--gd-display);
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

@media (max-width: 600px) {
  .gd-sheet__club,
  .gd-sheet__hero {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .gd-sheet__occupancy {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminLayout/GroupDetailsDialog.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;;;EAGE,oEAAoE;EACpE,0DAA0D;EAC1D,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;EAChB,iDAAiD;EACjD,yCAAyC;EACzC,gBAAgB;EAChB,mHAAmH;EACnH;;oFAEkF;AACpF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC;;;;;;;;;;;8BAW4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;EACE,wEAAwE;EACxE,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,mEAAmE;EACnE,uEAAuE;EACvE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,oEAAoE;AACtE;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC;;iFAE+E;AACjF;;AAEA;EACE;;iCAE+B;AACjC;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Club squad sheet — the group is a court, not a MUI form. */\n.gd-sheet.gmd-dlg .MuiDialog-paper,\n.gd-sheet .gmd-dlg-paper,\n.gmd-dlg.gd-sheet .gmd-dlg-paper {\n  --gd-display: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  --gd-body: \"IBM Plex Sans\", Poppins, system-ui, sans-serif;\n  font-family: var(--gd-body);\n  border-radius: 22px !important;\n  overflow: hidden;\n  background: var(--surface-color, #fff) !important;\n  color: var(--text-color, #111) !important;\n  max-width: 720px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--border-color, rgba(15, 23, 42, 0.1)));\n  box-shadow:\n    0 28px 70px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent),\n    0 2px 0 color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent) inset;\n}\n\n.gd-sheet__club {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 1.15rem 1.25rem 0.95rem;\n  background:\n    linear-gradient(\n      90deg,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 92%, #000) 0 7px,\n      transparent 7px\n    ),\n    radial-gradient(\n      90% 140% at 0% 0%,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) 0%,\n      transparent 58%\n    ),\n    var(--surface-color, #fff);\n}\n\n.gd-sheet .gmd-dlg__header-actions {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.gd-sheet .gmd-dlg__header-actions .gmd-dlg__close,\n.gd-sheet .gmd-dlg__header-actions .gmd-dlg__edit {\n  position: static !important;\n}\n\n.gd-sheet .gmd-dlg__edit {\n  color: var(--text-secondary, #666) !important;\n  background: rgba(0, 0, 0, 0.04) !important;\n}\n\n.dark-mode .gd-sheet .gmd-dlg__edit {\n  background: rgba(255, 255, 255, 0.06) !important;\n  color: var(--text-secondary, #aaa) !important;\n}\n\n.gd-sheet .gmd-dlg__edit:hover {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;\n  color: var(--brand-primary, #0877bc) !important;\n}\n\n.gd-sheet__club--with-edit .gd-sheet__club-copy {\n  padding-right: 4.75rem;\n}\n\n.gd-sheet__club-mark {\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  object-fit: contain;\n  flex-shrink: 0;\n  background: var(--surface-color, #fff);\n  border: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n  box-shadow: 0 8px 20px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);\n  padding: 4px;\n}\n\n.gd-sheet__club-mark--fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--gd-display);\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #fff;\n  background: var(--brand-primary, #0877bc);\n  padding: 0;\n}\n\n.gd-sheet__club-copy {\n  min-width: 0;\n  flex: 1;\n  padding-right: 2.2rem;\n}\n\n.gd-sheet__club-kicker {\n  display: block;\n  margin: 0 0 0.15rem;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.gd-sheet__club-name {\n  margin: 0;\n  font-family: var(--gd-display);\n  font-size: clamp(1.35rem, 3vw, 1.7rem);\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  line-height: 0.95;\n  text-transform: uppercase;\n  color: var(--text-color);\n}\n\n.gd-sheet__hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 0.85rem 1.1rem;\n  padding: 0.35rem 1.25rem 1rem;\n  border-bottom: 1px solid var(--border-color, rgba(15, 23, 42, 0.08));\n}\n\n.gd-sheet__group {\n  min-width: 0;\n  flex: 1;\n}\n\n.gd-sheet__group-name {\n  margin: 0;\n  font-family: var(--gd-display);\n  font-size: clamp(1.7rem, 4vw, 2.15rem);\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  line-height: 0.95;\n  text-transform: uppercase;\n  color: var(--text-color);\n}\n\n.gd-sheet__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.85rem;\n  margin: 0.45rem 0 0;\n  color: var(--text-secondary, #64748b);\n  font-size: 0.8rem;\n}\n\n.gd-sheet__lede {\n  margin: 0.4rem 0 0;\n  max-width: 28rem;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  color: var(--text-secondary, #64748b);\n}\n\n.gd-sheet__occupancy {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  padding: 0.35rem 0.15rem;\n}\n\n.gd-sheet__occupancy-stat {\n  display: flex;\n  flex-direction: column;\n}\n\n.gd-sheet__occupancy-n {\n  font-variant-numeric: tabular-nums;\n  font-size: 1.45rem;\n  font-weight: 650;\n  letter-spacing: -0.04em;\n  line-height: 1;\n  color: var(--text-color);\n}\n\n.gd-sheet__occupancy-label {\n  margin-top: 0.12rem;\n  color: var(--text-secondary, #64748b);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.gd-sheet .gl-court {\n  background: var(--brand-primary, #0877bc);\n  box-shadow:\n    inset 0 0 0 1px color-mix(in srgb, #fff 22%, transparent),\n    0 6px 14px color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);\n}\n\n.gd-sheet .gl-court__surface {\n  background:\n    linear-gradient(90deg, color-mix(in srgb, #000 22%, transparent), transparent 18% 82%, color-mix(in srgb, #000 22%, transparent)),\n    var(--brand-primary, #0877bc);\n}\n\n.gd-sheet__error {\n  margin: 0;\n  padding: 2rem 1.25rem;\n  text-align: center;\n  color: #b91c1c;\n}\n\n.gd-sheet .gmd-dlg__section-title {\n  font-family: var(--gd-display);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n@media (max-width: 600px) {\n  .gd-sheet__club,\n  .gd-sheet__hero {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .gd-sheet__occupancy {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
